import { Placement, PlacementArea } from '@bitrise/bitkit';
import { SeriesPointXY0, useReferenceElement } from '@bitrise/bitviz';
import React, { FunctionComponent } from 'react';

type Props = {
  point: SeriesPointXY0 | null;
};

const BuildTooltip: FunctionComponent<Props> = ({ children, point }) => {
  const referenceElement = useReferenceElement(point);

  return !referenceElement || !point ? null : (
    <Placement
      backgroundColor="black"
      borderRadius="x1"
      minWidth="8rem"
      placement="top"
      referenceElement={referenceElement}
      style={{ pointerEvents: 'none' }}
      textColor="gray-1"
      visible={!!point}
    >
      {() => (
        <PlacementArea padding="x3" withArrow>
          {children}
        </PlacementArea>
      )}
    </Placement>
  );
};

export default BuildTooltip;
